export const clamp = (value: number, min: number, max: number) => Math.min(Math.max(isNaN(value) ? 0 : value, min), max)
